import storage from 'redux-persist/lib/storage';

import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'linkpages',
      storage,
      whitelist: ['auth', 'user', 'migration'],
    },
    reducers
  );

  return persistedReducer;
};
